import api from "@/config/axios";
const URL_CLIENTE = "products/";

export default {
  getProductos() {
    return api.get(URL_CLIENTE + "socioProductos");
  },
  getCreditos(idCredito) {
    return api.get(URL_CLIENTE + "creditosSocio/" + idCredito || "");
  },
  getDetalleCreditos(accion) {
    return api.get(URL_CLIENTE + "socioCreditos/" + accion);
  },
  getCuentaCapital() {
    return api.get(URL_CLIENTE + "cuentaCapital");
  },
  getCuentaCapitalDetalle(idCuentaCapital) {
    return api.get(URL_CLIENTE + "cuentaCapitalDetalle/" + idCuentaCapital);
  },
  getCuentaCapitalBeneficiario() {
    return api.get(URL_CLIENTE + "beneficiarioCuentaCapital");
  },
  getProximoPago(idCredito) {
    return api.get(URL_CLIENTE + "proximoPago/" + idCredito);
  },
  getProximosPagos() {
    return api.get(URL_CLIENTE + "proximosPagos");
  }
};
